module.exports = __webpack_public_path__ + "img/infoIcon.95eb8cf3.png";